define('plugin/promotion/model/PromotionInstanceModel',['require','lib/model/BaseModel'],function (require) {

    var BaseModel = require('lib/model/BaseModel');
    //var PromotionModel = require('plugin/promotion/model/PromotionModel');

    /**
     * Promotion instance model
     *
     * @class PromotionInstanceModel
     */
    return BaseModel.extend({

        urlRoot: '/ext/promotion/instances/id/',

        defaults: {
            id: null,
            promotion: null,
            code: null,
            start_date: null,
            expired_date: null
        }

    });

});
